import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMicrosoftCodeExchange } from '../hooks/use-auth';
import { useAuthStore } from '../stores/auth-store';
import { useQueryClient } from '@tanstack/react-query';

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const microsoftCodeExchange = useMicrosoftCodeExchange();
  const qc = useQueryClient();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    const code = params.get('code');

    if (code) {
      processed.current = true;
      microsoftCodeExchange.mutate(
        { code },
        {
          onSuccess: () => {
            const user = useAuthStore.getState().user;
            if (user) {
              navigate(user.role === 'CLIENT' ? '/' : '/admin', { replace: true });
              return;
            }
            navigate('/login', { replace: true });
          },
          onError: () => {
            navigate('/login', { replace: true });
          },
        },
      );
      return;
    }

    navigate('/login', { replace: true });
  }, [params, navigate, qc, microsoftCodeExchange]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-gray-500">Se procesează autentificarea...</p>
    </div>
  );
}
